import { render, staticRenderFns } from "./LiveBroadcast.vue?vue&type=template&id=0979dc67"
import script from "./LiveBroadcast.vue?vue&type=script&lang=js"
export * from "./LiveBroadcast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports